Revolution.Module.extend({
    NAME: "mde.nav", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        // _.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        $('.js-toggle-mob-nav').on('click', this.toggleBurgerMenu);
        $('.secondary-menu .overlay').on('click', this.closeOpenMenu);
        $('.bk-menu-sm a span, .bk-menu-sm button span').on('click', this.accordion);
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
    },

    toggleBurgerMenu: function (e) {
        var $obj = $(e.currentTarget);
        var $burger = $obj.find('.burger-icon');
        var $secondaryMenu = $obj.closest('.main-nav').find('.secondary-menu');

        $burger.toggleClass('open');
        $secondaryMenu.slideToggle(600, function() {
            // if (Modernizr.touchevents) {
                if($secondaryMenu.is(':visible')) {
                    $('.overlay').fadeIn();
                    // $secondaryMenu.css('height', $(window).height() - $('header .main-nav').height());
                    // $secondaryMenu.css('overflow', 'scroll');
                    $('body').css('overflow', 'hidden');
                } else {
                    function closeMenu() {
                        $secondaryMenu.css('height', 'auto');
                        $secondaryMenu.css('overflow', '');
                    }
                    $('body').css('overflow', '');
                    $('.overlay').fadeOut();
                    setTimeout(closeMenu, 10000)
                }
            // }
        });

        //
    },

    closeOpenMenu: function (e) {
        var $burger = $('.js-toggle-mob-nav .burger-icon');
        var $secondaryMenu = $('.main-nav').find('.secondary-menu');

        $burger.toggleClass('open');
        $secondaryMenu.slideToggle(600, function() {
            if($secondaryMenu.is(':visible')) {
                $secondaryMenu.css('height', $(window).height() - $('header .main-nav').height());
                $secondaryMenu.css('overflow', 'scroll');
                $('body').css('overflow', 'hidden');
            } 
            else {
                function closeMenu() {
                    $secondaryMenu.css('height', 'auto');
                    $secondaryMenu.css('overflow', '');
                }
                $('body').css('overflow', '');
                $('.overlay').fadeOut();
                setTimeout(closeMenu, 10000)
            }
        });
    },

    accordion: function(e){
        if($(this).parent().next().length > 0) {
            e.preventDefault();
            $(this).parent().toggleClass('clicked');
            $(this).parent().next().slideToggle(300);
        }
    }
});
